import { ApiBooleanResult, ApiResult, JwtResult } from './data'
import serviceBase from '@/services/serviceBase'

export interface LogModel {
  Email: string;
  Password: string;
  Source?: string;
  Language: string;
  RememberMe: boolean;
}

export interface ChangePwdModel {
  OriPassword: string;
  NewPassword: string;
  Confirm?: string;
}

export default {
  async checkLoginAsync (jwt: string): Promise<ApiBooleanResult> {
    return await serviceBase.tryPostBooleanResult('/Auth/checkLoginStatus', null, { headers: { Authorization: 'bearer ' + jwt } })
  },
  async loginAsync (data: LogModel): Promise<ApiResult<JwtResult>> {
    data.Source = 'Web'
    return await serviceBase.tryPostResult<JwtResult>('/Auth/Login', data)
  },
  async changePwdAsync (data: ChangePwdModel) {
    return await serviceBase.tryPostResult('/Auth/ChangePwd', data)
  }
}
